import { Link2 } from '@geist-ui/icons';
import { Image } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import Link from '../Link';

interface SiteInfoBlockProps {
  image?: string;
  site: string;
  reportNumber: string;
}

const SiteInfoBlock: FC<SiteInfoBlockProps> = ({ image, site, reportNumber }) => {
  const [t] = useTranslation('reported');
  const [c] = useTranslation('common');

  return (
    <div className={styles['site-info-block']}>
      <Image
        alt={`${t('websiteImageAlt', { number: reportNumber, website: site })}`}
        radius={4}
        height={100}
        width={150}
        src={image}
      />
      <div className={styles['website']}>
        <Link navigateTo={site} targetBlank={true} aria-label={`${t('linkIconLabel')} ${site} ${c('opensInNewTab')}`}>
          <Link2 className={styles['link-outside']} aria-hidden size={16} />
        </Link>
        <span>{site}</span>
      </div>
    </div>
  );
};

export default SiteInfoBlock;
